import React, { useMemo, useState } from "react";
import { Space, Typography, Button } from "antd";
import VerifyIcon from "../../assets/icons/verify.svg";
import CrossIcon from "../../assets/icons/close-with-shadow.svg";
import { generateImageSeoAttributes } from "../../utls/imageAltGenerator";
import "./index.less";

type props = {
  className?: string;
  size: number;
  image: string | undefined;
  name?: string;
  username?: string;
  usernameAltText?: string;
  firstName?: string;
  lastName?: string;
  fontSize?: number;
  fontWeight?: boolean;
  lineHeight?: number;
  isShowVeritify?: boolean;
  fromSuggestions?: boolean;
  isLive?: boolean;
  isLargeView?: boolean;
  onClick?: () => void;
  profileName?: string;
};

const AvatarComponent: React.FC<props> = ({
  className,
  size,
  image,
  name,
  username,
  usernameAltText,
  fontSize,
  fontWeight,
  lineHeight,
  isShowVeritify,
  onClick,
  firstName,
  lastName,
  fromSuggestions,
  isLive = false,
  isLargeView = false,
  profileName,
}) => {
  const [isImageLarge, setIsImageLarge] = useState(false);

  const handleAvatarClick = () => {
    if (isLargeView) {
      setIsImageLarge(!isImageLarge);
    }
    if (onClick) onClick();
  };

  const imageSeo = useMemo(() => generateImageSeoAttributes(usernameAltText, profileName || name, "avatar"), [profileName, name, usernameAltText]);

  return (
    <>
      <Space className={`${className} gap-10`} direction="vertical" align="center">
        <Space className={`avatarWrap ${isLive ? "live-border" : ""}`}>
          <div className={`${isLive ? "avatarBorder" : ""}`}>
            <img
              className="avatar"
              src={image !== undefined ? image : ""}
              alt={imageSeo.alt}
              title={imageSeo.title}
              style={{
                width: `${size}px`,
                height: `${size}px`,
                borderRadius: "50%",
                objectFit: "cover",
                cursor: onClick || isLargeView ? "pointer" : "default",
              }}
              onClick={handleAvatarClick}
            />
            {isLive && <div className="live-badge">LIVE</div>}
          </div>
        </Space>
        {username && (
          <Space align="center">
            <Typography.Text
              className={`responsive-name text-white-color ${fontWeight ? "primary-font-bold" : "primary-font-regular"}`}
              style={{
                fontSize: fontSize,
                lineHeight: `${lineHeight}px`,
              }}
            >
              {name ? name : username}
            </Typography.Text>
            {isShowVeritify && <img src={VerifyIcon} alt="verify" />}
          </Space>
        )}
      </Space>

      {isImageLarge && (
        <div className="avatar-image-overlay" onClick={() => setIsImageLarge(false)}>
          <img className="cross-icon" src={CrossIcon} alt="close" title="close" />
          <img className="avatar-large-image" src={image} alt={imageSeo.alt} title={imageSeo.title} />
        </div>
      )}
    </>
  );
};

export default AvatarComponent;
